module.exports = __webpack_public_path__ + "img/376.eee74100.jpg";